<ng-container>
  <ng-container *ngIf="order$ | async as order">
    <app-order-detail-header [order]="order"
                             [isOrderLocked]="isOrderLocked$ | async"
                             [isCompleteCancelledOrOptout]="isCompleteCancelledOrOptout$ | async"
                             [canCompleteOrder]="canCompleteOrder"
                             (cancelled)="onCancelOrder()">
    </app-order-detail-header>
    <div *ngIf="isOrderLocked$ | async"
         class="order-detail-info-banner success-banner"
         [ngClass]="{
        'success-banner': order?.statusCode === 'COMPLETE',
        'warning-banner': order?.statusCode !== 'COMPLETE'
      }">
      <div class="banner-content">
        <span class="fas fa-lg me-2"
              [ngClass]="{
            'fa-check-circle': order?.statusCode === 'COMPLETE',
            'fa-exclamation-triangle': order?.statusCode !== 'COMPLETE'
          }">
        </span>
        Editing not allowed: Order status is currently {{ orderStatus$ | async | titleCaseStatusCode }}
      </div>
    </div>
    <div class="content85percent">
      <app-loan-information [toggleLoanInformationFormEdit]="toggleLoanInformationFormEdit"
                            [isOrderPreSign]="orderIsPresign$ | async"></app-loan-information>
      <div class="text-center marginTopFiftyPx loan-action-card-section">
        <div id="documentsCard" class="order-detail-card" *ngIf="!isRiw">
          <div class="card-content-container">
            <div class="card-header-wrapper">
              <mat-icon svgIcon="documents" class="card-header-icon"></mat-icon>
              <div class="card-header-title">
                <span>Documents</span>
              </div>
            </div>
            <div class="card-button-wrapper">
              <button type="button"
                      (click)="displayPdf(downloadDocumentsUrl, 'ClosingDocuments', 'COMPLETE')"
                      matTooltip="View Documents"
                      placement="bottom"
                      class="btn-icon"
                      [disabled]="!canViewDocuments"
                      data-cy="viewDocumentsButton">
                <svg width="21" height="17" stroke="currentColor" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6218 6.14367C13.7928 7.31467 13.7928 9.21567 12.6218 10.3887C11.4508 11.5597 9.54979 11.5597 8.37679 10.3887C7.20579 9.21767 7.20579 7.31667 8.37679 6.14367C9.54979 4.97067 11.4498 4.97067 12.6218 6.14367Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 8.26367C1.5 7.60467 1.652 6.95267 1.946 6.35167C3.461 3.25467 6.809 1.26367 10.5 1.26367C14.191 1.26367 17.539 3.25467 19.054 6.35167C19.348 6.95267 19.5 7.60467 19.5 8.26367C19.5 8.92267 19.348 9.57467 19.054 10.1757C17.539 13.2727 14.191 15.2637 10.5 15.2637C6.809 15.2637 3.461 13.2727 1.946 10.1757C1.652 9.57467 1.5 8.92267 1.5 8.26367Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <button type="button"
                      (click)="displayPdf(downloadExecutedPackageUrl, 'ExecutedClosingPackage')"
                      matTooltip="Download Documents"
                      placement="bottom"
                      class="btn-icon"
                      [disabled]="!canDownloadDocuments"
                      data-cy="downloadExecutedClosingPackageButton">
                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.25 10.2637V16.2637M11.25 16.2637L8.75 13.7637M11.25 16.2637L13.75 13.7637M5.74995 15.2637C3.34773 15.2699 1.36648 13.3836 1.25492 10.9839C1.14337 8.5843 2.94106 6.52228 5.33351 6.30566C5.80017 3.40029 8.30732 1.26367 11.2499 1.26367C14.1925 1.26367 16.6998 3.40029 17.1664 6.30566C19.5589 6.52228 21.3566 8.5843 21.245 10.9839C21.1335 13.3836 19.1522 15.2699 16.75 15.2637" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <button type="button"
                      (click)="displayPdf(printDocumentsUrl, 'ClosingDocuments')"
                      class="btn-icon"
                      matTooltip="Print Documents"
                      placement="bottom"
                      [disabled]="!canPrintDocuments"
                      data-cy="printDocumentsButton">
                <svg width="20" height="21" viewBox="0 0 20 21" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.25 6.26367V2.26367C5.25 1.71167 5.698 1.26367 6.25 1.26367H14.25C14.802 1.26367 15.25 1.71167 15.25 2.26367V6.26367M5.25 15.2637H3.25C2.145 15.2637 1.25 14.3687 1.25 13.2637V8.26367C1.25 7.15867 2.145 6.26367 3.25 6.26367H17.25C18.355 6.26367 19.25 7.15867 19.25 8.26367V13.2637C19.25 14.3687 18.355 15.2637 17.25 15.2637H15.25M5.25 9.26367H6.25M5.25 12.0637H15.25V18.2637C15.25 18.8157 14.802 19.2637 14.25 19.2637H6.25C5.698 19.2637 5.25 18.8157 5.25 18.2637V12.0637Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="isRON || isKnownSignerRON || isRiw" id="downloadVideoCard" class="order-detail-card">
          <div class="card-content-container">
            <div class="card-header-wrapper">
              <mat-icon svgIcon="video" class="card-header-icon"></mat-icon>
              <div class="card-header-title">
                <span>{{ videoCardTitle }}</span>
              </div>
            </div>
            <div class="card-button-wrapper">
              <span *ngIf="isRiw && isRecordingProcessing" class="recording-processing-text" data-cy="recordingProcessingText">
                Recording is processing. Please check back shortly.
              </span>
              <button *ngIf="!isOrderCancelled && !isOrderOptedOut"
                      type="button"
                      (click)="onDownloadClosingVideoClick()"
                      class="btn-secondary width-widget-default"
                      [disabled]="!canDownloadVideo"
                      [ngClass]="{'video-is-downloading': isVideoDownloading}"
                      data-cy="downloadVideoButton">
                <div class="loan-action-btn-text">
                  <span *ngIf="!isVideoDownloading; else videoIsDownloading">
                    <svg class="icon" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                      <path d="M11.25 10.2637V16.2637M11.25 16.2637L8.75 13.7637M11.25 16.2637L13.75 13.7637M5.74995 15.2637C3.34773 15.2699 1.36648 13.3836 1.25492 10.9839C1.14337 8.5843 2.94106 6.52228 5.33351 6.30566C5.80017 3.40029 8.30732 1.26367 11.2499 1.26367C14.1925 1.26367 16.6998 3.40029 17.1664 6.30566C19.5589 6.52228 21.3566 8.5843 21.245 10.9839C21.1335 13.3836 19.1522 15.2699 16.75 15.2637" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Download
                  </span>
                  <ng-template #videoIsDownloading>
                    <span>Downloading&nbsp;</span>
                    <span class="fas fa-spin fa-circle-notch"></span>
                  </ng-template>
                </div>
              </button>
              <button *ngIf="isOrderOptedOut || isOrderCancelled"
                      type="button"
                      (click)="onDownloadClosingVideoClick()"
                      class="btn-secondary width-widget-default"
                      [disabled]="!isVideoDownloadAvailable"
                      [ngClass]="{'video-is-downloading': isVideoDownloading}"
                      [showIfHasCapability]="[{
                        capabilityString: 'CanDownloadCancelledAndOptedOutOrderVideos',
                        type: 'system'
                      }]"
                      data-cy="downloadVideoButton">
                <div class="loan-action-btn-text">
                  <span *ngIf="!isVideoDownloading; else videoIsDownloading2">
                    <svg class="icon" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                      <path d="M11.25 10.2637V16.2637M11.25 16.2637L8.75 13.7637M11.25 16.2637L13.75 13.7637M5.74995 15.2637C3.34773 15.2699 1.36648 13.3836 1.25492 10.9839C1.14337 8.5843 2.94106 6.52228 5.33351 6.30566C5.80017 3.40029 8.30732 1.26367 11.2499 1.26367C14.1925 1.26367 16.6998 3.40029 17.1664 6.30566C19.5589 6.52228 21.3566 8.5843 21.245 10.9839C21.1335 13.3836 19.1522 15.2699 16.75 15.2637" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Download
                  </span>
                  <ng-template #videoIsDownloading2>
                    <span>Downloading&nbsp;</span>
                    <span class="fas fa-spin fa-circle-notch"></span>
                  </ng-template>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div id="joinVirtualMeetingCard" class="order-detail-card" *ngIf="isVirtualMeetingJoinCardVisible()">
          <div class="card-content-container">
            <div class="card-header-wrapper">
              <mat-icon svgIcon="signature" class="card-header-icon"></mat-icon>
              <div class="card-header-title">
                <span>Virtual Meeting</span>
              </div>
            </div>
            <div class="card-button-wrapper">
              <button type="button"
                      (click)="openVirtualMeetingHostSession()"
                      class="btn-secondary width-widget-default"
                      [disabled]="!canJoinVirtualMeeting"
                      data-cy="joinVirtualMeetingButton">
                <span>
                  <svg class="icon" viewBox="0 0 26 27" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25 12.0182L17 12.0182M17 12.0182L19.6667 9.35156M17 12.0182L19.6667 14.6849M11.6667 22.6849L17 22.6849C18.4733 22.6849 19.6667 21.4916 19.6667 20.0182L19.6667 18.6849M19.6667 5.35156L19.6667 4.01823C19.6667 2.5449 18.4733 1.35156 17 1.35156L3.66667 1.35156M11.6667 22.6822L11.6667 7.35558C11.6667 6.43558 11.1933 5.58091 10.4133 5.09425L5.08 1.76091C3.304 0.651579 1 1.92758 1 4.02225L1 19.3476C1 20.2676 1.47333 21.1222 2.25333 21.6089L7.58667 24.9422C9.36267 26.0529 11.6667 24.7756 11.6667 22.6822Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>Join
                </span>
              </button>
            </div>
          </div>
        </div>
        <ng-container *ngIf="!isRiw">
          <div id="joinSigningCard" class="order-detail-card"
               *ngIf="joinSigningUrl !== null; else loadingButton">
            <div class="card-content-container">
              <div class="card-header-wrapper">
                <mat-icon svgIcon="signature" class="card-header-icon"></mat-icon>
                <div class="card-header-title">
                  <span>Signing</span>
                </div>
              </div>
              <div class="card-button-wrapper">
                <button type="button"
                        (click)="openSigningSession(joinSigningUrl)"
                        class="btn-secondary width-widget-default"
                        [disabled]="!canJoinSigning">
                  <span>
                    <svg class="icon" viewBox="0 0 26 27" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M25 12.0182L17 12.0182M17 12.0182L19.6667 9.35156M17 12.0182L19.6667 14.6849M11.6667 22.6849L17 22.6849C18.4733 22.6849 19.6667 21.4916 19.6667 20.0182L19.6667 18.6849M19.6667 5.35156L19.6667 4.01823C19.6667 2.5449 18.4733 1.35156 17 1.35156L3.66667 1.35156M11.6667 22.6822L11.6667 7.35558C11.6667 6.43558 11.1933 5.58091 10.4133 5.09425L5.08 1.76091C3.304 0.651579 1 1.92758 1 4.02225L1 19.3476C1 20.2676 1.47333 21.1222 2.25333 21.6089L7.58667 24.9422C9.36267 26.0529 11.6667 24.7756 11.6667 22.6822Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>Join
                  </span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <div id="notaryInfoCard"
             class="order-detail-card"
             *ngIf="!isRiw">
          <div class="card-content-container">
            <div class="card-header-wrapper">
              <mat-icon svgIcon="shield-star" class="card-header-icon"></mat-icon>
              <div class="card-header-title">
                <span>Notarization Info</span>
              </div>
            </div>
            <div class=" card-button-wrapper">
              <button type="button"
                      (click)="displayPdf(downloadNotarizationInformationPdfUrl, 'NotarizationInformation')"
                      class="btn-secondary width-widget-default"
                      [disabled]="!canDownloadNotarizationInformation">
                <div class="loan-action-btn-text">
                  <span>
                    <svg class="icon" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                      <path d="M11.25 10.2637V16.2637M11.25 16.2637L8.75 13.7637M11.25 16.2637L13.75 13.7637M5.74995 15.2637C3.34773 15.2699 1.36648 13.3836 1.25492 10.9839C1.14337 8.5843 2.94106 6.52228 5.33351 6.30566C5.80017 3.40029 8.30732 1.26367 11.2499 1.26367C14.1925 1.26367 16.6998 3.40029 17.1664 6.30566C19.5589 6.52228 21.3566 8.5843 21.245 10.9839C21.1335 13.3836 19.1522 15.2699 16.75 15.2637" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Download
                  </span>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="canViewAuditLog" id="auditLogCard" class="order-detail-card">
          <div class="card-content-container">
            <div class="card-header-wrapper">
              <mat-icon svgIcon="documents" class="card-header-icon"></mat-icon>
              <div class="card-header-title">
                <span>Audit Log</span>
              </div>
            </div>
            <div class="card-button-wrapper">
              <button type="button"
                      (click)="openAuditLogModal()"
                      class="btn-secondary width-widget-default"
                      [disabled]="!hasAuditLogs">
                <div class="loan-action-btn-text">
                  <span>View</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="section-outline marginTopSixtyPx" data-cy="participantsSection">
        <div class="d-flex flex-row">
          <span class="section-header document-text-header pt-1">
            Participants
          </span>
          &nbsp;
          <button *ngIf="!(isOrderLocked$ | async)"
                  class="btn-primary m-3 ms-auto"
                  data-backdrop="static"
                  data-keyboard="false"
                  (click)="openParticipantModal()"
                  [showIfHasCapability]="[
              {
                capabilityString: 'CanAddParticipant',
                type: 'order',
                id: order?.id
              }
            ]">
            Add Participant
          </button>
        </div>
        <ng-container *ngIf="participants$ | async as participants; else loadingParticipants">
          <app-participant-list #participantTable
                                *ngIf="participants?.length > 0; else noParticipants"
                                [participants]="participants"
                                [showSessionLink]="isOrderReadyOrInprogress"
                                [showActions]="isOrderReadyOrInprogress"
                                [participantPresignStatuses]="participantPresignStatuses"
                                [orderId]="order?.id"
                                [isOrderLocked]="isOrderLocked$ | async"
                                (geturlCalled)="getClosingUrlAction($event)"
                                (editActionCalled)="editParticipantAction($event)"
                                (removeActionCalled)="removeParticipantAction($event)"
                                (resetLoginActionCalled)="openResetLoginModal($event)">
          </app-participant-list>
        </ng-container>
      </div>
      <div class="section-outline marginTopSixtyPx"
           data-cy="organizersSection"
           *ngIf="
              this.capabilitiesService.userHasCapability(
                'order',
                'CanViewOrganizers',
                order?.id
              ) | async"
              >
        <div class="d-flex flex-row">
          <span class="section-header document-text-header pt-1">
            Order Organizers
          </span>
          <button *ngIf="!(isOrderLocked$ | async)"
                  class="btn-primary m-3 ms-auto"
                  data-backdrop="static"
                  data-keyboard="false"
                  (click)="openAddOrderOrganizer()"
                  [showIfHasCapability]="[
                  {
                    capabilityString: 'CanAddOrganizer',
                    type: 'order',
                    id: order?.id
                  }
                ]">
            Add Order Organizer
          </button>
        </div>
        <app-order-organizer-list #organizerTable
                                  [showActions]="isOrderReady"
                                  [orderId]="order?.id">
        </app-order-organizer-list>
      </div>
      <div class="section-outline marginTopSeventyFivePx" data-cy="documentsSection" *ngIf="!isRiw">
        <div class="d-flex flex-row">
          <span class="section-header document-text-header mb-4 pt-1">Documents</span>
          <div class="m-3 ms-auto">
            <mat-slide-toggle     
                class="me-3"
                (change)="toggleVoidedDocuments()"
                matTooltip="Show voided documents toggle"
                labelPosition="before">
              <span class="mat-slide-toggle-content">Show Voided Documents</span>
            </mat-slide-toggle>
            <button *ngIf="!(isOrderLocked$ | async)"
                    class="btn-primary"
                    data-backdrop="static"
                    data-keyboard="false"
                    (click)="openUploadDocument()"
                    [showIfHasCapability]="[
                      {
                        capabilityString: 'CanAddDocument',
                        type: 'order',
                        id: order?.id
                      }
                    ]">
              Upload Documents
            </button>
          </div>
        </div>
        <div *ngIf="(this.ruleViolations?.documentRules.length > 0)"
             class="document-rule-section">
          <img src="assets/images/fa-exclamation-circle-o.png" class="ms-2 float-start exclamation-img" alt="Exclamation point" />
          <span class="ms-3">
            Document(s) need attention. Hover over the "<i class="fa-solid fa-triangle-exclamation"></i> Needs Attention" status chips below to view rule violations.
          </span>
        </div>
        <ng-container *ngIf="combinedDocuments$ | async as documents; else loadingDocuments">
          <app-documents-list *ngIf="documents?.length > 0; else noDocuments"
                              [order]="order"
                              [documents]="documents"
                              [isOrderLocked]="isOrderLocked$ | async"
                              [ruleViolations]="ruleViolations"
                              (loadDocumentsCalled)="loadDocuments()">
          </app-documents-list>
        </ng-container>
      </div>
    </div>

    <ng-template #loadingButton>
      <div class="order-detail-card">
        <div class="card-content-container">
          <div class="card-header-wrapper">
            <mat-icon svgIcon="signature" class="card-header-icon"></mat-icon>
            <div class="card-header-title">
              <span>Signing</span>
            </div>
          </div>
          <div class="card-button-wrapper">
            <button type="button" disabled class="btn-secondary width-widget-default">
              <div class="loan-action-btn-icon-default">
                <span class="fas fa-spinner fa-spin"></span>
              </div>
            </button>
          </div>
        </div>        
      </div>
    </ng-template>

    <ng-template #browserNotSupportedModal>
      <div class="modal-header d-flex align-items-center justify-content-between">
        <h5 class="modal-title" id="saveTemplateModalLabel">
          Browser not supported
        </h5>
        <span class="fas fa-times text-white" (click)="closeModal()"></span>
      </div>
      <div class="modal-body d-flex align-items-center justify-content-center flex-column">
        <p>Please use Google Chrome to complete your Remote Online Notarization.</p>
        <p>If you need further assistance, please call Nexsys Support at: (844) 913-1386.</p>
      </div>
    </ng-template>

    <ng-template #loadingParticipants>
      <div class="jumbotron empty-jumbotron-message">
        <div class="d-flex justify-content-center align-items-center">
          <span class="jumbotron-heading">
            Loading Participants
          </span>
          <span class="fas fa-spinner fa-spin primary-color-txt fa-2x ms-2"></span>
        </div>
        <app-skeleton-loading-list [rowCount]="2"
                                   [tableName]="'participants'"></app-skeleton-loading-list>
      </div>
    </ng-template>

    <ng-template #noParticipants>
      <div class="jumbotron empty-jumbotron-message"
           data-cy="emptyParticipantsMessage">
        <span class="fw-bold">No participants to display.</span>
        <br />
        <span *ngIf="!(isOrderLocked$ | async)"
              class="jumbotron-text"
              [showIfHasCapability]="[
            {
              capabilityString: 'CanAddParticipant',
              type: 'order',
              id: order?.id
            }
          ]">
          Start adding your borrowers, sellers, and signing agent to this order by clicking
          <a class="nav-link fw-bold"
             (click)="openParticipantModal()">Add Participant</a>
          above
        </span>
      </div>
    </ng-template>

    <ng-template #loadingDocuments>
      <div class="jumbotron empty-jumbotron-message">
        <div class="d-flex justify-content-center align-items-center">
          <span class="jumbotron-heading">
            Loading Documents
          </span>
          <span class="fas fa-spinner fa-spin primary-color-txt fa-2x ms-2"></span>
        </div>
        <app-skeleton-loading-list [rowCount]="2"
                                   [tableName]="'documents'"></app-skeleton-loading-list>
      </div>
    </ng-template>

    <ng-template #noDocuments>
      <div class="jumbotron empty-jumbotron-message"
           data-cy="emptyDocumentsMessage">
        <span class="fw-bold">No documents added.</span>
        <br />
        <span *ngIf="!(isOrderLocked$ | async)"
              [showIfHasCapability]="[
            {
              capabilityString: 'CanAddDocument',
              type: 'order',
              id: order?.id
            }
          ]">
          Click
          <a class="nav-link fw-bold add-doc-text" (click)="openUploadDocument()">
            Upload Documents
          </a>
          to start adding documents for the signing session.
        </span>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
